import { ReferenceParser } from "@methodset/calculator-ts";
import { InputWidgetConfiguration, Widget } from '@methodset/application-client-ts';

export class InputWidgetSync {

    public static parser = (widget: Widget): string[] => {
        const configuration = widget.configuration as InputWidgetConfiguration;
        const refs: string[] = [];
        refs.push(...ReferenceParser.extract(configuration.hideId, true));
        refs.push(...ReferenceParser.extract(configuration.variableId, true));
        return refs;
    }

    public static updater = (widget: Widget, target: string, replacement: string): void => {
        const configuration = widget.configuration as InputWidgetConfiguration;
        configuration.hideId = ReferenceParser.update(configuration.hideId, target, replacement, true);
        configuration.variableId = ReferenceParser.update(configuration.variableId, target, replacement, true);
    }

}
